import React, { useEffect, useState, useMemo } from "react";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Button,
  Input,
} from "reactstrap";
import { useLocation, useHistory } from "react-router-dom";
import { postMethod } from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";
import { showSuccessToast, showErrorToast } from "../../../../_services/notification";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const RetailerPreview = (props) => {
  const history = useHistory();
  const query = useQuery();
  const idParamRaw = query.get("id");
  const idParam = idParamRaw === "" ? null : idParamRaw;

  const [loading, setLoading] = useState(false);
  const [productlist, setProductlist] = useState([]);
  const [param, setParam] = useState({
    tran_id: idParam == null ? "0" : idParam,
    entry_no: "",
    title: "Sale",
    mobile: "",
    customer_id: "",
    customer_name: "",
    remarks: "",
    gst: 0,
  });

  const [selectedSubCategory, setselectedSubCategory] = useState([]);

  const [branchDetails, setBranchDetails] = useState({});
  const [selectedProducts, setSelectedProducts] = useState([]); // products added to bill
  //   -----------------

  // ---------------- API / effects ----------------
  useEffect(() => {
    // initial load
    setLoading(true);

    // get branch details
    const branchId = localStorage.getItem("jwl_branch_id");
    if (branchId) {
      postMethod("api/masters/branch/preview", { branch_id: branchId })
        .then((d) => setBranchDetails(d))
        .catch((e) => console.error("branch preview error", e));
    }

    const runPreview = async () => {
      try {
        if (idParam !== null) {
          const temp = window.atob(idParam);
          const dataD = await postMethod("api/transactions/stockRetailerSales/preview", { tran_id: temp });
          const data = dataD.data && dataD.data[0];
          if (data) {

            setParam({
              ...param,
              tran_id: temp,
              entry_no: data.entry_no,
              title: data.title,
              mobile: data.mobile,
              customer_id: data.customer_id,
              customer_name: data.customer_name,
              customer_sale_products: data.products,
              remarks: data.remarks,
            });
            setselectedSubCategory(data.products);
          }
        } else {
          const dataD = await postMethod("api/transactions/stockRetailerSales/preview", { tran_id: 0 });
          const data = dataD.data && dataD.data[0];
          if (data) setParam((p) => ({ ...p, entry_no: data.entry_no }));
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    runPreview();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  //   ---------------

  return (
    <>

      {loading && <Loader />}

      <Row className="mb-3">
        <Col sm={4}>
          <h4>Add Customer Sales</h4>
        </Col>
        <Col sm={4}>
          <FormGroup>
            <Label>Title</Label>
            <Input
              value={param.title}
              disabled
            />
          </FormGroup>
        </Col>
        <Col sm={4}>
          <FormGroup>
            <Label>Entry No.</Label>
            <Input value={param.entry_no} disabled />
          </FormGroup>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col sm={4}>
          <FormGroup>
            <Label>Mobile</Label>
            <Input
              type="number"
              value={param.mobile}
              disabled
            />
          </FormGroup>
        </Col>
        <Col sm={4}>
          <FormGroup>
            <Label>Customer Name</Label>
            <Input value={param.customer_name}
              disabled
            />
          </FormGroup>
        </Col>
      </Row>


      <Row>
        <Col sm={8}>
          <Table bordered>
            <tbody>
              {selectedSubCategory.length > 0 ? (
                <Col sm={12}>
                  <Table bordered>
                    <thead>
                      <tr>
                        <th width="12%">Product Code </th>
                        <th>Product Name</th>
                        <th>Gender</th>
                        <th>Price</th>
                        <th>qty</th>
                        <th>Image</th>

                      </tr>
                    </thead>
                    <tbody>
                      {selectedSubCategory.length > 0
                        ? selectedSubCategory.map((obj, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                {i + 1}) {obj.product_code}
                              </td>
                              <td>{obj.product_name}</td>
                              <td>{obj.gender}</td>
                              <td>{obj.price}</td>
                              <td>{obj.qty}</td>
                              <td>
                                <img
                                  src={obj.url_image + "" + obj.image_path}
                                  width="36px"
                                  alt=""
                                />{" "}
                              </td>

                            </tr>
                          );
                        })
                        : null}
                    </tbody>
                  </Table>
                </Col>
              ) : (<tr>
                <td colSpan="5" className="text-center">
                  No Data
                </td>
              </tr>
              )}
            </tbody>
          </Table>
        </Col>


        <Col sm={4}>
          <Card>
            <CardHeader>Bill Summary</CardHeader>
            <CardBody>
              <Table borderless size="sm">
                <tbody>
                  <tr>
                    <td>No. of items</td>
                    <td className="text-end">{"no-item"}</td>
                  </tr>
                  <tr>
                    <td>Subtotal</td>
                    {/* <td className="text-end">Paise :: ₹{subtotalAmount.toFixed(2)}</td> */}
                    <td className="text-end">Paise ::</td>
                  </tr>
                </tbody>
              </Table>
            </CardBody>
            <CardFooter className="d-flex gap-2">
              <Button color="primary" className="flex-fill" >CheckBill</Button>
            </CardFooter>
          </Card>

          <div className="mt-3">
            <FormGroup>
              <Label>Remarks</Label>
              {/* <Input type="textarea" value={param.remarks} onChange={(e) => setParam((p) => ({ ...p, remarks: e.target.value }))} /> */}
              <Input type="textarea" />
            </FormGroup>
          </div>
        </Col>
      </Row>


    </>
  );

}

export default RetailerPreview;